export const MARK_OH_CASE_IMMUNISATION_CLEAR = "MARK_OH_CASE_IMMUNISATION_CLEAR";

export const MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS = "MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS";

export const ADD_BLOOD_TEST_RESULT = "ADD_BLOOD_TEST_RESULT";
